/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//Assets
import walletIcon from "../../assets/Wallet_Icon.svg";

import { shortenAddress } from "../../utils/shortenAddress";
import { Switch } from "../../components/Switch";
import { CustomTextbar } from "../../components/CustomTextbar";

interface IItem {
  name: string
  title: string
}
const switchItems = [{ name: 'TYPE_1', title: 'Token Transfer' }, { name: 'TYPE_2', title: 'Signature Message (QR Code)' }]

const ConfigSection = ({
  nftData,
  assetWallet,
  storageWalletAddress,
  setStorageWalletAddress,
  activeItem,
  setActiveItem,
  isInitializingReq
}: {
  nftData: any;
  assetWallet: string;
  storageWalletAddress: any;
  setStorageWalletAddress: any;
  activeItem: any;
  setActiveItem: any;
  isInitializingReq: boolean
}) => {

  return (
    <>
      <section
        css={css`
          display: flex;
          margin-top: 40px;
          border: 1px solid #ccc4b3;
          border-radius: 12px;
          padding: 32px;
          flex-direction: column;
          gap: 35px;
        `}
      >
        <>
          <div
            css={css`
                    display: 100%;
                    display: flex;
                  `}
          >
            <span
              css={css`
                      display: flex;
                      flex-direction: column;
                      width: 75%;
                      margin-top: 70px;
                    `}
            >
              <h1
                css={css`
                        font-weight: 700;
                        font-size: 24px;
                        margin: 0;
                      `}
              >
                Enter Wallet You Will Be Moving Your Asset To
              </h1>
              <p
                css={css`
                        font-weight: 500;
                        font-size: 16px;
                        margin: 0;
                        margin-top: 16px;
                        color: #757272;
                      `}
              >
                Ideally destination address will be cold storage
              </p>
            </span>
            <img
              css={css`
                width: 128px;
                height: 128px;
              `}
              src={walletIcon}
              alt="" />
          </div>
          <div
            css={css`
              margin-top: auto;
            `}
          >
            <CustomTextbar
              config={{
                title: 'Current Asset Wallet Address',
                value: shortenAddress(assetWallet)
              }}
            />
            {
              activeItem?.name === 'TYPE_1'
                ? <input
                  placeholder="Enter your storage ID"
                  css={css`
                    width: 100%;
                    height: 44px;
                    background: #ffffff;
                    border: 1px solid #ccc4b3;
                    border-radius: 12px;
                    padding: 12px 24px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #a29b8b;
                    margin-top: 20px;
                  `}
                  type="text"
                  value={storageWalletAddress}
                  onChange={(e) => {
                    setStorageWalletAddress(e.target.value);
                  }} />
                : <></>
            }


          </div>
        </>
        <Switch toggle={(item: IItem) => { setActiveItem(item) }} items={switchItems} />
      </section>
    </>
  );
};

export default ConfigSection;
